import projectPaymentsReportComponent from './project-payments-report.component';

const projectPaymentsReportModule = angular.module('projectPaymentsReport', [
])
  .component('projectPaymentsReport', projectPaymentsReportComponent)
  .name;

export default projectPaymentsReportModule;
